export default function SuitableCompanies() {
  const industries = [
    { icon: 'ri-building-2-line', name: 'B2B' },
    { icon: 'ri-store-line', name: 'B2C' },
    { icon: 'ri-hammer-line', name: 'Производство' },
    { icon: 'ri-service-line', name: 'Услуги' },
    { icon: 'ri-ship-line', name: 'Логистика' },
    { icon: 'ri-truck-line', name: 'Дистрибуция' },
    { icon: 'ri-shopping-bag-line', name: 'Ритейл' },
    { icon: 'ri-bank-line', name: 'Финансы' },
    { icon: 'ri-home-gear-line', name: 'Строительство' },
    { icon: 'ri-code-box-line', name: 'IT' },
  ];

  return (
    <section id="industries" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Для каких компаний подходит обучение
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Программа адаптируется под любую отрасль и модель продаж. Главное — наличие коммуникации с клиентом.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {industries.map((ind, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 text-center hover:bg-teal-50 transition-colors duration-300 border border-gray-100 hover:border-teal-200">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mx-auto mb-3">
                <i className={`${ind.icon} text-xl text-white`}></i>
              </div>
              <span className="text-sm font-semibold text-gray-900">{ind.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}